import { ArrayOps } from '../lift';
/**
 * Appends one item at the end of the Array.
 */
export function append(item) {
    return new ArrayOps(this.value().concat([item]));
}
ArrayOps.prototype.append = append;
